import { render, staticRenderFns } from "./AssessmentHelp.vue?vue&type=template&id=7ebce9f9&"
import script from "./AssessmentHelp.vue?vue&type=script&lang=js&"
export * from "./AssessmentHelp.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentHelp.vue?vue&type=style&index=0&id=7ebce9f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports